/**
 * Active Society Context Utility
 * Manages active society selection in localStorage and broadcasts changes across tabs and components.
 */

export const ACTIVE_SOCIETY_STORAGE_KEY = 'xservices_active_society_id';
export const ACTIVE_SOCIETY_CHANGE_EVENT = 'xservices:active-society-change';

export function getActiveSocietyId(): number | null {
  if (typeof window === 'undefined') return null;
  const raw = localStorage.getItem(ACTIVE_SOCIETY_STORAGE_KEY);
  if (!raw) return null;
  const parsed = Number(raw);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

export function setActiveSocietyId(societyId: number | null): void {
  if (typeof window === 'undefined') return;
  if (societyId && Number.isFinite(societyId) && societyId > 0) {
    localStorage.setItem(ACTIVE_SOCIETY_STORAGE_KEY, String(societyId));
  } else {
    localStorage.removeItem(ACTIVE_SOCIETY_STORAGE_KEY);
  }
  window.dispatchEvent(
    new CustomEvent(ACTIVE_SOCIETY_CHANGE_EVENT, { detail: { societyId } })
  );
}

export function clearActiveSocietyId(): void {
  setActiveSocietyId(null);
}
